exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrap[data-v-165d17dc] {\n    position: fixed;\n    z-index: 10019;\n    bottom: 180px;\n    right: -60px;\n    cursor: pointer;\n    -webkit-transition: all 0.5s;\n    transition: all 0.5s;\n}\n.active[data-v-165d17dc] {\n    right: 30px;\n}\n", ""]);

// exports
